export default __webpack_public_path__ + "static/N0206-dbf77bed2929fa90a4588d9e46297780.png";